import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsStandUpPaddlingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M24 14.5h-5V12h5zM19 18.5h5V16h-5zM23 22.5h-3V20h3z" />
        <path d="M21.04.086c.299-.11.62-.11.92 0 .413.153 1.954.846 3.379 3.033 1.418 2.178 2.66 5.745 2.66 11.54 0 10.058-3.68 16.062-4.11 16.727a1.34 1.34 0 01-1.13.614h-2.518a1.34 1.34 0 01-1.13-.614C18.68 30.721 15 24.716 15 14.66c0-5.795 1.242-9.362 2.661-11.54C19.086.932 20.627.24 21.041.086zm.46 2.564c-.078.05-.165.11-.26.182-.397.301-.937.812-1.484 1.652-1.09 1.674-2.256 4.733-2.256 10.175 0 8.004 2.486 13.203 3.397 14.84h1.206c.911-1.637 3.397-6.836 3.397-14.84 0-5.442-1.166-8.5-2.256-10.175-.547-.84-1.087-1.35-1.484-1.652a4.162 4.162 0 00-.26-.182zM4.014 28.609a4.549 4.549 0 003.077.02c.996-.346 1.517-1.192 1.763-1.867l.603-1.658a7.917 7.917 0 00-.264-6.054l-.213-.456 5.361-14.73 1.253.457.855-2.35L11.594.206l-.855 2.349 1.253.456-5.367 14.744-.435.203a7.916 7.916 0 00-4.094 4.468l-.603 1.658c-.246.675-.39 1.658.15 2.563a4.55 4.55 0 002.37 1.963zm2.257-2.341a2.05 2.05 0 01-1.402-.009 2.05 2.05 0 01-1.08-.894c-.002-.004-.016-.027-.016-.096 0-.076.017-.189.07-.331l.603-1.658a5.417 5.417 0 012.58-2.948 5.417 5.417 0 01.082 3.917l-.603 1.658a.999.999 0 01-.16.298c-.045.053-.07.061-.074.063z" />
      </g>
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsStandUpPaddlingNormalMedium;
